<template>
<div id="app">
  <OttHeaderWidget :languageUrl="languageUrl"></OttHeaderWidget>
  <div class="dev-app">
    <div class="container" id="dev-app-container">
      <Breadcrumb></Breadcrumb>
      <h1 id="main-content" tabindex="-1">{{ $t('appTitle') }}</h1>
      <search-form v-show="showMap" v-on:search-by-fields="onSearchByFields"></search-form>
      <router-view
        v-on:update-map="onSearchByFields"
        v-on:fetch-next-resultset="onSearchByFields"
        v-on:order-resultset="onSearchByFields"
        :key="refreshMap"
      ></router-view>
      <div class="row no-gutters align-items-top justify-content-center">
        <div class="col-lg">
          <div v-show="showMap" class="devapp-download-all-box">
            <button id='btn-download-excel' class="btn-sm btn-primary btn-download"
              v-bind:aria-label="$t('download.text')"
              v-on:click.prevent="confirmDownload()">
              {{ $t('download.text') }}
            </button>
            &nbsp;
          </div>
        </div>
        <!-- div class="col-lg">
          <div class="devapp-feedback-box">
            <a v-bind:href="$t('feedbackSurveyLink')"
              id="btn-feedback-link"
              v-bind:aria-label="$t('feedbackSurveyAriaLabel')"
            >{{ $t('feedbackSurveyText') }}</a>
          </div>
        </div -->
      </div>
    </div>
  </div>
  <OttFooterWidget></OttFooterWidget>
  <div id="ottux-topbutton"
    data-target-id="main-content"
    data-z-index="1">
  </div>
</div>
</template>
<script>
  import OttFooterWidget from '@/components/OttFooterWidget.vue';
  import Breadcrumb from '@/components/Breadcrumb.vue';
  import SearchForm from '@/components/SearchForm.vue';
  import OttHeaderWidget from '@/components/OttHeaderWidget.vue';
  
  import { fetchDevApps, fetchInitialFeatures } from '@/util/api'

  export default {
    name: 'app',
    data: function() {
      return {
        contentHeight: 0,
        renderTime: Date.now(),
        refreshMap: Date.now()
      }
    },
    components: {
      OttHeaderWidget,
      Breadcrumb,
      SearchForm,
      OttFooterWidget,
    },
    methods: {
      confirmDownload: function() {
        this.$fire({
          title: '<span style="font-family: Helvetica;">' + this.$t('download.title') + '</span>',
          html: '<span style="font-family: Helvetica;">' + this.$t('download.message') + '</span>',
          showCloseButton: false,
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonText: this.$t('download.yes'),
          confirmButtonAriaLabel: this.$t('download.yes'),
          cancelButtonText: this.$t('download.no'),
          cancelButtonAriaLabel:  this.$t('download.no'),
        }).then((r) => {
          if(r.value) {
            //console.log('r', r)
            window.open(this.$t('download.link'), '_self')
          }
        })
      },
      onSearchByFields: function() {
        // Use a prop to force the search results to refresh 
        this.renderTime = Date.now()
        this.refreshMap = Date.now()
        console.log('onSearchByFields')

        this.$gtag.pageview({
          page_path: '/search?s=' + this.appStatus + '&t=' + this.searchText + '&a=' + this.appType + '&w=' + this.ward
        })

        console.log('/search?s=' + this.appStatus + '&t=' + this.searchText + '&a=' + this.appType + '&w=' + this.ward + '&o=' + this.orderBy + '&ob=' + this.orderType)

        this.updateSearchResults();

        //console.log('App.vue', 'onSearchFields: clicked!')
        this.$router.push({
          name: 'Search',
          query: { s: encodeURI(this.appStatus), t: encodeURI(this.searchText), a: encodeURI(this.appType), w: encodeURI(this.ward), i: encodeURI(this.searchIndex), b: encodeURI(this.bounds), o: encodeURI(this.orderBy), ob: encodeURI(this.orderType) }
        })
      },
      updateSearchResults: async function() {
        console.log('App.vue', 'updateSearchResults: executed!')
        try {
          var results = null
          //console.log('language', this.$i18n.currentLanguage())
          if (this.searchText || this.appStatus || this.appType || this.ward ) {
            results = await fetchDevApps(this.appStatus, this.searchText, this.appType, this.ward, this.searchIndex, this.bounds, this.orderBy, this.orderType, this.languageUrl)
          }
          // Save the results so components can render themselves
          this.$store.commit('searchResults', results)
        } catch (e) {
          console.log('Error fetching data', e)
        }
      },
      preLoadDevApps: async function() {
        try {
          if (!this.$store.state.allFeatures) {
            const results = await fetchInitialFeatures()
            if (results) {
              this.$store.commit('allFeatures', results)
              this.refreshMap = Date.now()
            }
          }
        } catch (e) {
          console.log('Error fetching data', e)
        }
      },
      resizeElements: function() {
        this.contentHeight = (window.innerHeight * 0.65) + 'px'
        if (window.innerHeight <= 768) {
          this.contentHeight = (window.innerHeight * 1.5) + 'px'
        }

        let mapContainer = document.getElementById("default-map-container");
        if(mapContainer) {
          if (window.innerHeight <= 768) {
            mapContainer.style.height = (window.innerHeight * 0.7) + 'px';
          } else {
            mapContainer.style.height = (window.innerHeight * 0.65) + 'px';
          }
        }
      }
    },
    computed: {
      searchText: function() {
        return this.$store.state.searchText
      },
      appType: function() {
        return this.$store.state.appType
      },
      appStatus: function() {
        return this.$store.state.appStatus
      },
      ward: function() {
        return this.$store.state.ward
      },
      bounds: function() {
        return this.$store.state.bounds
      },
      orderBy: function() {
        return this.$store.state.orderBy
      },
      orderType: function() {
        return this.$store.state.orderType
      },
      searchIndex: function() {
        return this.$store.state.searchIndex
      },
      showMap: function() {
        const route = this.$route
        return route.meta.showMap
      },
      languageUrl: function() {
        return this.$i18n.currentLanguage()
      }
    },
    watch: {
      $route: function() {
        // Anytime a navigation takes place, close the menu
        this.refreshMap = Date.now()
      },
      appType: function () {
        this.updateSearchResults()
      },
      appStatus: function () {
        this.updateSearchResults()
      },
      ward: function () {
        this.updateSearchResults()
      },
      searchText: function () {
        this.updateSearchResults()
      },
      bounds: function () {
        this.updateSearchResults()
      },
      searchIndex: function () {
        this.updateSearchResults()
      },
      orderBy: function () {
        this.updateSearchResults()
      },
      orderType: function () {
        this.updateSearchResults()
      } 
    },
    created: function() {
      window.addEventListener('resize', this.resizeElements)
      const store = this.$store
      const route = this.$route
      
      this.preLoadDevApps()

      // Detect variables from the query string if needed. This allows us to
      // act on "deep" links (that may have been shared externally, or bookmarked).
      switch (route.name) {
      case 'Home': {
        // If this is the first time the user sees the home page, show the menu
        if (!store.state.homeVisited) {
          store.commit('homeVisited')
        }
        break
      }
      case 'Search': {
        let querySearchText = route.query && route.query.t ? decodeURI(route.query.t).trim() : null
        let queryAppStatus = route.query && route.query.s ? decodeURI(route.query.s).trim() : null
        let queryAppType = route.query && route.query.a ? decodeURI(route.query.a).trim() : null
        let queryWard = route.query && route.query.w ? decodeURI(route.query.w).trim() : null
        let queryBound = route.query && route.query.b ? decodeURI(route.query.b).trim() : null
        let queryIndex = route.query && route.query.i ? decodeURI(route.query.i).trim() : null
        let queryOrder = route.query && route.query.o ? decodeURI(route.query.o).trim() : null
        let queryOrderBy = route.query && route.query.ob ? decodeURI(route.query.ob).trim() : null

        if (querySearchText || queryAppStatus || queryAppType || queryWard || queryBound || queryIndex || queryOrder || queryOrderBy) {
          // Setting the search text will trigger an update
          this.$store.commit('appStatus', queryAppStatus);
          this.$store.commit('appType', queryAppType);
          this.$store.commit('searchText', querySearchText);
          this.$store.commit('ward', queryWard);
          this.$store.commit('searchIndex', queryIndex);
          this.$store.commit('orderBy', queryOrder);
          this.$store.commit('orderType',queryOrderBy);
          this.$store.commit('bounds', queryBound)
        } else {
          // If no search terms were supplied, redirect home
          store.commit('resetSearch')
          this.$router.push({ name: 'Home' })
        } 
      break
      }
      case 'Devapp': {
        // Redirect to the details
        this.$router.push({ name: 'DevappDetails' })
        break
      }
      case 'DevappDetails': {
        let devappId = route.params && route.params.id ? route.params.id : null
        if (devappId) {
          console.log('Revise logic here')
        } else {
          // If no devapp key was supplied, redirect home
          store.commit('resetSearch')
          this.$router.push({ name: 'Home' })
        }
        break
      }
    }
    },
    destroyed: function() {
      window.removeEventListener('resize', this.resizeElements)
    },
    mounted: function() {
      this.resizeElements()
    },
  }
</script>

<style scoped lang="scss">
@import '@/scss/app.scss';

.map-container {
  display: flex;
}
</style>
